import React, { useState, useEffect } from 'react';

interface Size {
  width: number;
  height: number;
}

export default function useWindowSize(): Size {
  const isSSR = typeof window === 'undefined';
  const [windowSize, setWindowSize] = useState<Size>({
    width: isSSR ? 1200 : window.innerWidth,
    height: isSSR ? 800 : window.innerHeight,
  });
  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return windowSize;
}
